$(() => {
  let hideFooter = false;

  function checkScroll() {
    if ($(window).scrollTop() >= $(window).height() * 0.2 && !hideFooter) {
      $('.sticky-footer').removeClass('hidden');
    } else {
      $('.sticky-footer').addClass('hidden');
    }
  }

  $(window).on('scroll resize', () => {
    checkScroll();
  });

  $('.email-sign-up-field').on('focus', () => {
    hideFooter = true;
    $('.sticky-footer').addClass('hidden');
  });

  $('.email-sign-up-field').on('blur', () => {
    hideFooter = false;
    checkScroll();
  });
});
